import type { BlockViewProps } from '../../core/types';
import {
    UserStoriesRenderer,
    type UserStoriesData
} from '../../directives/renderers/UserStoriesRenderer';

export function UserStoriesBlockView({
    data,
    onDataChange,
}: BlockViewProps<UserStoriesData>) {
    return <UserStoriesRenderer data={data} onChange={onDataChange} />;
}
